/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { BidderDto } from '../models/bidder-dto';
import { FindBiddersResponseDto } from '../models/find-bidders-response-dto';
import { Operation } from '../models/operation';

@Injectable({
  providedIn: 'root',
})
export class GeneratedBidderService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation findBidders
   */
  static readonly FindBiddersPath = '/api/bidders';

  /**
   * Finds bidders by a given filter.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findBidders()` instead.
   *
   * This method doesn't expect any request body.
   */
  findBidders$Response(params: {
    auc_id?: number;
    user_id?: number;
    inumis_id?: number;
    number?: number;
    s?: string;
    primary?: boolean;
    '$sortby': string;
    '$sortdir': string;
    '$page'?: number;
    '$maxpagesize': number;
    '$goto_num'?: number;
    includeRelatedUsers?: boolean;
    'X-API-Version'?: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<FindBiddersResponseDto>> {

    const rb = new RequestBuilder(this.rootUrl, GeneratedBidderService.FindBiddersPath, 'get');
    if (params) {
      rb.query('auc_id', params.auc_id, {});
      rb.query('user_id', params.user_id, {});
      rb.query('inumis_id', params.inumis_id, {});
      rb.query('number', params.number, {});
      rb.query('s', params.s, {});
      rb.query('primary', params.primary, {});
      rb.query('$sortby', params['$sortby'], {});
      rb.query('$sortdir', params['$sortdir'], {});
      rb.query('$page', params['$page'], {});
      rb.query('$maxpagesize', params['$maxpagesize'], {});
      rb.query('$goto_num', params['$goto_num'], {});
      rb.query('includeRelatedUsers', params.includeRelatedUsers, {});
      rb.header('X-API-Version', params['X-API-Version'], {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<FindBiddersResponseDto>;
      })
    );
  }

  /**
   * Finds bidders by a given filter.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `findBidders$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findBidders(params: {
    auc_id?: number;
    user_id?: number;
    inumis_id?: number;
    number?: number;
    s?: string;
    primary?: boolean;
    '$sortby': string;
    '$sortdir': string;
    '$page'?: number;
    '$maxpagesize': number;
    '$goto_num'?: number;
    includeRelatedUsers?: boolean;
    'X-API-Version'?: string;
  },
  context?: HttpContext

): Observable<FindBiddersResponseDto> {

    return this.findBidders$Response(params,context).pipe(
      map((r: StrictHttpResponse<FindBiddersResponseDto>) => r.body as FindBiddersResponseDto)
    );
  }

  /**
   * Path part for operation getBidder
   */
  static readonly GetBidderPath = '/api/bidders/{id}';

  /**
   * Gets a bidder by its id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getBidder()` instead.
   *
   * This method doesn't expect any request body.
   */
  getBidder$Response(params: {
    id: number;
    'X-API-Version'?: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<BidderDto>> {

    const rb = new RequestBuilder(this.rootUrl, GeneratedBidderService.GetBidderPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
      rb.header('X-API-Version', params['X-API-Version'], {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BidderDto>;
      })
    );
  }

  /**
   * Gets a bidder by its id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getBidder$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getBidder(params: {
    id: number;
    'X-API-Version'?: string;
  },
  context?: HttpContext

): Observable<BidderDto> {

    return this.getBidder$Response(params,context).pipe(
      map((r: StrictHttpResponse<BidderDto>) => r.body as BidderDto)
    );
  }

  /**
   * Path part for operation patchBidder
   */
  static readonly PatchBidderPath = '/api/bidders/{id}';

  /**
   * Patches a bidder.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `patchBidder()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  patchBidder$Response(params: {
    id: number;
    'X-API-Version'?: string;
    body: Array<Operation>
  },
  context?: HttpContext

): Observable<StrictHttpResponse<BidderDto>> {

    const rb = new RequestBuilder(this.rootUrl, GeneratedBidderService.PatchBidderPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.header('X-API-Version', params['X-API-Version'], {});
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BidderDto>;
      })
    );
  }

  /**
   * Patches a bidder.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `patchBidder$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  patchBidder(params: {
    id: number;
    'X-API-Version'?: string;
    body: Array<Operation>
  },
  context?: HttpContext

): Observable<BidderDto> {

    return this.patchBidder$Response(params,context).pipe(
      map((r: StrictHttpResponse<BidderDto>) => r.body as BidderDto)
    );
  }

  /**
   * Path part for operation getBidderCustomIdMappingCsv
   */
  static readonly GetBidderCustomIdMappingCsvPath = '/api/bidders/auction/{auctionId}/bidder-customid-mapping';

  /**
   * Gets a CSV mapping of bidder numbers to user CustomIds for a given auction.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getBidderCustomIdMappingCsv()` instead.
   *
   * This method doesn't expect any request body.
   */
  getBidderCustomIdMappingCsv$Response(params: {
    auctionId: number;
    'X-API-Version'?: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<Blob>> {

    const rb = new RequestBuilder(this.rootUrl, GeneratedBidderService.GetBidderCustomIdMappingCsvPath, 'get');
    if (params) {
      rb.path('auctionId', params.auctionId, {});
      rb.header('X-API-Version', params['X-API-Version'], {});
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Blob>;
      })
    );
  }

  /**
   * Gets a CSV mapping of bidder numbers to user CustomIds for a given auction.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getBidderCustomIdMappingCsv$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getBidderCustomIdMappingCsv(params: {
    auctionId: number;
    'X-API-Version'?: string;
  },
  context?: HttpContext

): Observable<Blob> {

    return this.getBidderCustomIdMappingCsv$Response(params,context).pipe(
      map((r: StrictHttpResponse<Blob>) => r.body as Blob)
    );
  }

  /**
   * Path part for operation getHighestBidsPerBidderCsv
   */
  static readonly GetHighestBidsPerBidderCsvPath = '/api/bidders/auction/{auctionId}/highest-bids-per-bidder';

  /**
   * Gets a CSV export of highest bids per bidder for a given auction.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getHighestBidsPerBidderCsv()` instead.
   *
   * This method doesn't expect any request body.
   */
  getHighestBidsPerBidderCsv$Response(params: {
    auctionId: number;
    'X-API-Version'?: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<Blob>> {

    const rb = new RequestBuilder(this.rootUrl, GeneratedBidderService.GetHighestBidsPerBidderCsvPath, 'get');
    if (params) {
      rb.path('auctionId', params.auctionId, {});
      rb.header('X-API-Version', params['X-API-Version'], {});
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Blob>;
      })
    );
  }

  /**
   * Gets a CSV export of highest bids per bidder for a given auction.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getHighestBidsPerBidderCsv$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getHighestBidsPerBidderCsv(params: {
    auctionId: number;
    'X-API-Version'?: string;
  },
  context?: HttpContext

): Observable<Blob> {

    return this.getHighestBidsPerBidderCsv$Response(params,context).pipe(
      map((r: StrictHttpResponse<Blob>) => r.body as Blob)
    );
  }

  /**
   * Path part for operation getBidderStatsExcel
   */
  static readonly GetBidderStatsExcelPath = '/api/bidders/auction/{auctionId}/bidder-stats-excel';

  /**
   * Gets an Excel export of bidder statistics for a given auction.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getBidderStatsExcel()` instead.
   *
   * This method doesn't expect any request body.
   */
  getBidderStatsExcel$Response(params: {
    auctionId: number;
    'X-API-Version'?: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<Blob>> {

    const rb = new RequestBuilder(this.rootUrl, GeneratedBidderService.GetBidderStatsExcelPath, 'get');
    if (params) {
      rb.path('auctionId', params.auctionId, {});
      rb.header('X-API-Version', params['X-API-Version'], {});
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Blob>;
      })
    );
  }

  /**
   * Gets an Excel export of bidder statistics for a given auction.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getBidderStatsExcel$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getBidderStatsExcel(params: {
    auctionId: number;
    'X-API-Version'?: string;
  },
  context?: HttpContext

): Observable<Blob> {

    return this.getBidderStatsExcel$Response(params,context).pipe(
      map((r: StrictHttpResponse<Blob>) => r.body as Blob)
    );
  }

}
